import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Eye({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M14.1222 9.87999C15.2922 11.05 15.2922 12.95 14.1222 14.12C12.9422 15.29 11.0422 15.29 9.87221 14.12C8.69221 12.94 8.69221 11.04 9.87221 9.86999C11.0422 8.69699 12.9422 8.69699 14.1122 9.86999M3.00021 12C3.00021 11.34 3.15021 10.689 3.44021 10.08C4.95021 6.97999 8.30022 4.98999 11.9942 4.98999C15.6842 4.98999 19.0242 6.97999 20.5442 10.07C20.8342 10.67 20.9842 11.32 20.9842 11.98C20.9842 12.63 20.8242 13.291 20.5342 13.89C19.0142 16.98 15.6642 18.97 11.9742 18.97C8.27421 18.97 4.93421 16.97 3.42021 13.88C3.12021 13.27 2.97021 12.62 2.97021 11.96L3.00021 12Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Eye;